import "./LabelIconDropdown.scss";
import React from "react";
import { IonCol, IonContent, IonGrid, IonIcon, IonPopover, IonRow } from "@ionic/react";
import clsx from "clsx";

import briefcaseIcon from "../../assets/svg/accountIcons/briefcase.svg";
import profileIcon from "../../assets/svg/accountIcons/profile.svg";
import mailIcon from "../../assets/svg/accountIcons/mail.svg";
import boxIcon from "../../assets/svg/accountIcons/box.svg";
import anchorIcon from "../../assets/svg/accountIcons/anchor.svg";
import ribbonIcon from "../../assets/svg/accountIcons/ribbon.svg";
import cubeIcon from "../../assets/svg/accountIcons/cube.svg";
import cloudIcon from "../../assets/svg/accountIcons/cloud.svg";
import coffeeIcon from "../../assets/svg/accountIcons/coffee.svg";
import sunIcon from "../../assets/svg/accountIcons/sun.svg";
import moonIcon from "../../assets/svg/accountIcons/moon.svg";
import editIcon from "../../assets/svg/accountIcons/edit.svg";
import giftIcon from "../../assets/svg/accountIcons/gift.svg";
import heartIcon from "../../assets/svg/accountIcons/heart.svg";
import diskIcon from "../../assets/svg/accountIcons/disk.svg";
import starIcon from "../../assets/svg/accountIcons/star.svg";

const accountColors = [
  "#53A6DE",
  "#4C71EC",
  "#6752EE",
  "#8A4CE0",
  "#883FB1",
  "#C06AD0",
  "#C95E98",
  "#EE90A9",
  "#B63854",
  "#CA5646",
  "#DF9754",
  "#EAD067",
  "#A6C84A",
  "#90CD82",
  "#7CC0AD",
  "#8C979D",
];

const accountIcons = [
  { icon: briefcaseIcon, name: "briefcase" },
  { icon: profileIcon, name: "profile" },
  { icon: mailIcon, name: "mail" },
  { icon: boxIcon, name: "box" },
  { icon: anchorIcon, name: "anchor" },
  { icon: ribbonIcon, name: "ribbon" },
  { icon: cubeIcon, name: "cube" },
  { icon: cloudIcon, name: "cloud" },
  { icon: coffeeIcon, name: "coffee" },
  { icon: sunIcon, name: "sun" },
  { icon: moonIcon, name: "moon" },
  { icon: editIcon, name: "edit" },
  { icon: giftIcon, name: "gift" },
  { icon: heartIcon, name: "heart" },
  { icon: diskIcon, name: "disk" },
  { icon: starIcon, name: "star" },
];

interface Props {
  selectedIcon: any;
  selectedIconName: any;
  selectedColor: any;
  onSetSelectedIcon: Function;
  onSetSelectedIconName: Function;
  onSetSelectedColor: Function;
}

const LabelIconDropdown: React.FC<Props> = ({
  selectedIcon,
  selectedIconName,
  selectedColor,
  onSetSelectedIcon,
  onSetSelectedIconName,
  onSetSelectedColor,
}) => {

  return (
    <IonPopover
    trigger="trigger-button"
    mode="ios"
    size="auto"
    arrow={false}
    className="label-icon-dropdown"
  >
    <IonContent scrollY={false} className="ion-no-background">
      <div className="label-icons-container">
        <div className="colors-container">
          <IonGrid>
            <IonRow>
              {accountColors.map((val: any) => {
                const style: any = {
                  background: val,
                };
                return (
                  <IonCol
                    key={val}
                    size="1.5"
                    onClick={() => {
                      onSetSelectedColor(val);
                    }}
                  >
                    <div
                      className={clsx("color-item-container", {
                        selected: selectedColor === val,
                      })}
                    >
                      <div className="color-item" style={style} />
                    </div>
                  </IonCol>
                );
              })}
            </IonRow>
          </IonGrid>
        </div>
        <div className="icons-container">
          <IonGrid>
            <IonRow>
              {accountIcons.map((val: any) => {
                const style: any = {};

                if (selectedIconName === val.name) {
                  style.background = selectedColor;
                }

                return (
                  <IonCol
                    key={val.name}
                    size="1.5"
                    className={clsx({
                      selected: selectedIconName === val.name,
                    })}
                    onClick={() => {
                      onSetSelectedIcon(val.icon);
                      onSetSelectedIconName(val.name);
                    }}
                  >
                    <div
                      style={style}
                      className={clsx("icon-item-container", {
                        selected: selectedColor === val,
                      })}
                    >
                      <IonIcon icon={val.icon} />
                    </div>
                  </IonCol>
                );
              })}
            </IonRow>
          </IonGrid>
        </div>
      </div>
    </IonContent>
  </IonPopover>
  )
}

export default LabelIconDropdown;